/**
 * Closes all accordions (with class "accordion__item")
 */
export const closeAllAccordions = () => {
  const accordions = document.querySelectorAll<HTMLElement>(".accordion__item");

  for (const accordion of accordions) {
    changeAccordionState(accordion, false);
  }
};

/**
 * Opens / closes the specified bootstrap collapse element (accordion)
 * @param accordionElement The HTML element to modify the state of
 * @param shouldOpen Whether to open / close the accordion
 */
const changeAccordionState = (
  accordionElement: HTMLElement,
  shouldOpen: boolean
) => {
  const accordionCollapsible =
    accordionElement.querySelector<HTMLElement>(".js-collapsible");
  const accordionHeader = accordionElement.querySelector(".accordion__header");

  if (!accordionCollapsible || !accordionHeader) {
    return;
  }

  if (shouldOpen) {
    accordionCollapsible.classList.add("show");
    accordionHeader.classList.remove("collapsed");
  } else {
    accordionCollapsible.classList.remove("show");
    accordionHeader.classList.add("collapsed");
  }
};

/**
 * Wrapper for opening / closing an accordion with an ID
 * @param accordionId The HTML ID of the element
 * @param shouldOpen Whether to open / close the accordion
 */
const changeAccordionStateById = (accordionId: string, shouldOpen: boolean) => {
  const accordion = document.getElementById(accordionId);

  if (!accordion) {
    return;
  }

  changeAccordionState(accordion, shouldOpen);
};

/**
 * Closes the accordion with the specified ID
 * @param accordionId The HTML ID of the accordion
 */
export const closeAccordionById = (accordionId: string) => {
  changeAccordionStateById(accordionId, false);
};

/**
 * Open the accordion with the specified ID
 * @param accordionId The HTML ID of the accordion
 */
export const openAccordionById = (accordionId: string) => {
  changeAccordionStateById(accordionId, true);
};
